// This file was autogenerated, don't edit it manually.
// Use `make regenerate-frontend` in {REPOSITORY_ROOT}/core directory.

export enum Permission {
    accessControlManagePeers = 'access_control_manage_peers',
    adsConnectionsManage = 'ads_connections_manage',
    adsConnectionsView = 'ads_connections_view',
    agentsManage = 'agents_manage',
    agentsView = 'agents_view',
    auditView = 'audit_view',
    backstageAccess = 'backstage_access',
    birdProxyRead = 'bird_proxy_read',
    birdProxyWrite = 'bird_proxy_write',
    brandsAudienceCreate = 'brands_audience_create',
    brandsAudienceEdit = 'brands_audience_edit',
    brandsCampaignDraftsManage = 'brands_campaign_drafts_manage',
    brandsCampaignsManage = 'brands_campaigns_manage',
    budgetsManage = 'budgets_manage',
    businessAccountEmployeeMembersManage = 'business_account_employee_members_manage',
    businessAccountMembersAdd = 'business_account_members_add',
    businessAccountMembersManage = 'business_account_members_manage',
    businessAccountMembersView = 'business_account_members_view',
    businessAccountSalesforceAccountIdEdit = 'business_account_salesforce_account_id_edit',
    businessAccountsCustomize = 'business_accounts_customize',
    businessAccountsManage = 'business_accounts_manage',
    businessAccountsView = 'business_accounts_view',
    channelStrategiesManage = 'channel_strategies_manage',
    channelStrategiesView = 'channel_strategies_view',
    channelsManage = 'channels_manage',
    contentLibraryManage = 'content_library_manage',
    contentLibraryView = 'content_library_view',
    emailChannelsManage = 'email_channels_manage',
    employeeFeaturesAccess = 'employee_features_access',
    employeesManage = 'employees_manage',
    experimentalFeaturesAccess = 'experimental_features_access',
    googleAnalyticsEventMappingManage = 'google_analytics_event_mapping_manage',
    importerRun = 'importer_run',
    jobCampaignAdvertisementsManage = 'job_campaign_advertisements_manage',
    jobCampaignDraftAdvertisementsManage = 'job_campaign_draft_advertisements_manage',
    jobCampaignDraftsManage = 'job_campaign_drafts_manage',
    jobCampaignsManage = 'job_campaigns_manage',
    jobylonManageAllTalents = 'jobylon_manage_all_talents',
    jobylonManageSettings = 'jobylon_manage_settings',
    jobylonManageSingleTalents = 'jobylon_manage_single_talents',
    komboIntegrationsManage = 'kombo_integrations_manage',
    leadsAutomationsManage = 'leads_automations_manage',
    leadsCustomFieldsManage = 'leads_custom_fields_manage',
    leadsGeneralSettingsManage = 'leads_general_settings_manage',
    leadsJourneyAutomationsManage = 'leads_journey_automations_manage',
    leadsJourneysManage = 'leads_journeys_manage',
    leadsTalentpoolsManage = 'leads_talentpools_manage',
    linkedinCredentialsManage = 'linkedin_credentials_manage',
    microserviceProxyAccess = 'microservice_proxy_access',
    otysConnectionsManage = 'otys_connections_manage',
    productItemRolesManage = 'product_item_roles_manage',
    productItemsManage = 'product_items_manage',
    productItemsView = 'product_items_view',
    productRolesManage = 'product_roles_manage',
    productUtmSettingsManage = 'product_utm_settings_manage',
    productsView = 'products_view',
    rolesEdit = 'roles_edit',
    socialCampaignsManage = 'social_campaigns_manage',
    ssoConnectionsManage = 'sso_connections_manage',
    ssoConnectionsView = 'sso_connections_view',
    ssoSettingsManage = 'sso_settings_manage',
    supermetricsConnectionsManage = 'supermetrics_connections_manage',
    talentStatusesManage = 'talent_statuses_manage',
    talentsManage = 'talents_manage',
    talentsRemove = 'talents_remove',
    usersApiKeyManage = 'users_api_key_manage',
    usersEditProfile = 'users_edit_profile',
    usersViewAll = 'users_view_all',
    websiteWidgetManage = 'website_widget_manage',
    websiteWidgetsView = 'website_widgets_view',
}
